<ownerlist-report class="ownerlist-report">
  <report-header date="{ opts.date }"/>

  <div>
    <h1 class="ambita-report-h1">KART - Eierliste</h1>
    <p>Vedlagte liste (csv-fil) angir hjemmelshavere for berørte eiendommer innenfor det polygonet som er valgt.</p>
    <report-map config="{ opts.mapConfig }" task="{ opts.mapTask }"/>
  </div>

  <script>
    import '../common/reportHeader.tag';
    import '../reportMap/reportMap.tag';
    import './ownerListReport.scss';
  </script>
</ownerlist-report>
